import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Route, Routes, useLocation } from 'react-router-dom';
// Mobile Pages import
import MobileBenefits from './Mobile/Benefits';
import MobileEditProfile from './Mobile/EditProfile';
import MobileEmailOtpPage from './Mobile/EmailOtpPage';
import MobileFellowsPage from './Mobile/Fellows';
import MobileHome from './Mobile/Home';
import MobileJoinInfo from './Mobile/JoinInfoPage';
import MobileLogin from './Mobile/Login';
import MobileMembershipProfile from './Mobile/MembershipProfile';
import MobileMissionDetail from './Mobile/MissionDetail';
import MobileNewDetail from './Mobile/NewDetail';
import MobileNews from './Mobile/News';
import MobileNotifications from './Mobile/Notifications';
import MobilePageDetail from './Mobile/PageDetail';
import MobileRegistration from './Mobile/Registration';
import MobileRenewalPayment from './Mobile/RenewalPayment';
import MobileSettings from './Mobile/Settings';
import MobileSuccessPage from './Mobile/SuccessPage';
import MobileVoucherDetail from './Mobile/VoucherDetail';
// Web Pages import
import WebBenefits from './Web/Benefits';
import WebEditProfile from './Web/EditProfile';
import WebEmailOtpPage from './Web/EmailOtpPage';
import WebFellowsPage from './Web/Fellows';
import WebHome from './Web/Home';
import WebJoinInfo from './Web/JoinInfoPage';
import WebLogin from './Web/Login';
import WebMembershipProfile from './Web/MembershipProfile';
import WebMissionDetail from './Web/MissionDetail';
import WebNewDetail from './Web/NewDetail';
import WebNews from './Web/News';
import WebNotifications from './Web/Notifications';
import WebPageDetail from './Web/PageDetail';
import WebRegistration from './Web/Registration';
import WebRenewalPayment from './Web/RenewalPayment';
import WebSettings from './Web/Settings';
import WebSuccessPage from './Web/SuccessPage';
import WebVoucherDetail from './Web/VoucherDetail';
// ----------------------------------------------------------------
import Context from '../provider';
import ErrorDialog from '../dialogs/ErrorDialog';
import ErrorPage from './ErrorPage';
import FootMenuDialog from '../dialogs/FootMenuDialog';
import LandingPopupDialog from '../dialogs/LandingPopupDialog';
import LoadingBackdrop from '../components/LoadingBackdrop';
import MemberCodeDialog from '../dialogs/MemberCodeDialog';
import MessageDialog from '../dialogs/MessageDialog';
import React, { useContext } from 'react';
import RootVars from '../theme/RootVars';
import UserInfoDialog from '../dialogs/UserInfoDialog';
import config from '../config';

import WebNavHeaderBarComponent from '../components/WebNavHeaderBarComponent';

export default function AppRouter() {
  const { error, isMobile } = useContext(Context);
  const location = useLocation();
  const mobileTransitionFade = {
    enter: `mobile-page-transition-enter-fade`,
    enterActive: `mobile-page-transition-enter-active-fade`,
    exit: `mobile-page-transition-exit-fade`,
    exitActive: `mobile-page-transition-exit-active-fade`
  };

  const webTransitionFade = {
    enter: `web-page-transition-enter-fade`,
    enterActive: `web-page-transition-enter-active-fade`,
    exit: `web-page-transition-exit-fade`,
    exitActive: `web-page-transition-exit-active-fade`
  };

  return (
    (<div>
      <RootVars />
      <TransitionGroup>
        <CSSTransition
          key={location.key}
          classNames={isMobile ? mobileTransitionFade : webTransitionFade}
          timeout={400}
        >

          <div className='app-router'>
          {
            !error && !isMobile &&
              <WebNavHeaderBarComponent />
          }
            <Routes location={location}>
              {!error && isMobile &&
                // Mobile端Web入口
                <>
                  <Route exact path={`${config.basename}`} element={<MobileHome />} />
                  <Route exact path={`${config.basename}home`} element={<MobileHome />} />
                  <Route exact path={`${config.basename}index.html`} element={<MobileHome />} />
                  <Route exact path={`${config.basename}join-membership-program`} element={<MobileJoinInfo />} />
                  <Route exact path={`${config.basename}login`} element={<MobileLogin />} />
                  <Route exact path={`${config.basename}registration`} element={<MobileRegistration />} />
                  <Route exact path={`${config.basename}renewal`} element={<MobileRenewalPayment />} />
                  <Route exact path={`${config.basename}benefit/*`} element={<MobileBenefits />} />
                  <Route exact path={`${config.basename}settings`} element={<MobileSettings />} />
                  <Route exact path={`${config.basename}notifications`} element={<MobileNotifications />} />
                  <Route exact path={`${config.basename}about-fohkdc`} element={<MobileFellowsPage />} />
                  <Route exact path={`${config.basename}news`} element={<MobileNews />} />
                  <Route exact path={`${config.basename}news-detail/*`} element={<MobileNewDetail />} />
                  <Route exact path={`${config.basename}mission/*`} element={<MobileMissionDetail />} />
                  <Route exact path={`${config.basename}voucher/*`} element={<MobileVoucherDetail />} />
                  <Route exact path={`${config.basename}profile`} element={<MobileMembershipProfile />} />
                  <Route exact path={`${config.basename}setting/profile/*`} element={<MobileEditProfile />} />
                  <Route exact path={`${config.basename}setting/email-edit`} element={<MobileEditProfile />} />
                  <Route exact path={`${config.basename}setting/forgot-email`} element={<MobileEditProfile />} />
                  <Route exact path={`${config.basename}email-otp`} element={<MobileEmailOtpPage />} />
                  <Route exact path={`${config.basename}success`} element={<MobileSuccessPage />} />
                  {/* <Route exact path={`${config.basename}login`} element={<Login />} />
                  <Route exact path={`${config.basename}signup`} element={<Signup />} />
                  <Route exact path={`${config.basename}forgot-password`} element={<ForgotPassword />} />
                  <Route exact path={`${config.basename}edit-profile`} element={<EditProfile />} />
                  <Route exact path={`${config.basename}card`} element={<MembershipCard />} />
                  <Route exact path={`${config.basename}home`} element={<Home />} />
                  <Route exact path={`${config.basename}mission/*`} element={<MissionDetail />} />
                  <Route path={`${config.basename}reward/*`} element={<RewardItemDetail />} />
                  <Route path={`${config.basename}item/*`} element={<RewardItemDetail />} />
                  <Route exact path={`${config.basename}my-wallet`} element={<MyWallet />} />
                  <Route exact path={`${config.basename}transaction`} element={<TransactionHistory />} />
                  <Route exact path={`${config.basename}news`} element={<NewsAndPromotion type="news" />} />
                  <Route exact path={`${config.basename}promotions`} element={<NewsAndPromotion type="promotion" />} />
                  <Route path={`${config.basename}news/*`} element={<NewsAndPromotionDetail type="news" />} />
                  <Route path={`${config.basename}promotion/*`} element={<NewsAndPromotionDetail type="promotion" />} /> */}
                  <Route path={`${config.basename}*`} element={<MobilePageDetail />} />
                </>
              }
              {!error && !isMobile &&
                // PC端Web入口
                <>

                  <Route exact path={`${config.basename}`} element={<WebHome />} />
                  <Route exact path={`${config.basename}index.html`} element={<WebHome />} />
                  <Route exact path={`${config.basename}home`} element={<WebHome />} />
                  <Route exact path={`${config.basename}join-membership-program`} element={<WebJoinInfo />} />
                  <Route exact path={`${config.basename}login`} element={<WebLogin />} />
                  <Route exact path={`${config.basename}registration`} element={<WebRegistration />} />
                  <Route exact path={`${config.basename}notifications`} element={<WebNotifications />} />
                  <Route exact path={`${config.basename}email-otp`} element={<WebEmailOtpPage />} />
                  <Route exact path={`${config.basename}renewal`} element={<WebRenewalPayment />} />
                  <Route exact path={`${config.basename}news`} element={<WebNews />} />
                  <Route exact path={`${config.basename}settings`} element={<WebSettings />} />
                  <Route exact path={`${config.basename}news-detail/*`} element={<WebNewDetail />} />
                  <Route exact path={`${config.basename}voucher/*`} element={<WebVoucherDetail />} />
                  <Route exact path={`${config.basename}benefit/*`} element={<WebBenefits />} />
                  <Route exact path={`${config.basename}mission/*`} element={<WebMissionDetail />} />
                  <Route exact path={`${config.basename}profile`} element={<WebMembershipProfile />} />
                  <Route exact path={`${config.basename}setting/profile/*`} element={<WebEditProfile />} />
                  <Route exact path={`${config.basename}setting/email-edit`} element={<WebEditProfile />} />
                  <Route exact path={`${config.basename}setting/forgot-email`} element={<WebEditProfile />} />
                  <Route exact path={`${config.basename}success`} element={<WebSuccessPage />} />

                  <Route exact path={`${config.basename}about-fohkdc`} element={<WebFellowsPage />} />
                  <Route path={`${config.basename}*`} element={<WebPageDetail />} />
                </>
              }
              {error && error === 'NEWWORK_ERROR' && <Route path='*' element={<ErrorPage type="network" />} /> }
              {error && error === 'NO_PERMISSION' && <Route path='*' element={<ErrorPage type="permission" />} /> }
            </Routes>
          </div>
        </CSSTransition>
      </TransitionGroup>
      <UserInfoDialog />
      {
        isMobile &&
        <FootMenuDialog />
      }
      <MessageDialog />
      <ErrorDialog />
      <LandingPopupDialog />
      <MemberCodeDialog />
      <LoadingBackdrop />
    </div>)
  );
}